"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

/**
 * A hook to handle when a user presses escape.
 * It uses a passed-in dependency array to determine when to add/remove its event listener.
 * 
 * 
 * @param {function} [handler = (e) => {}] - Callback function executed when a user presses escape.
 * @param {array} [dependencies = []] - Depency array for updating when to add/remove event listener.
 * @returns {void}
*/
var useEscapeHandler = function useEscapeHandler() {
  var handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (e) {};
  var dependencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var escapeHandler = function escapeHandler(e) {
    if (e.code === 'Escape') {
      handler();
    }
  };

  (0, _react.useEffect)(function () {
    var _document;

    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('keyup', escapeHandler);
    return function () {
      var _document2;

      (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.removeEventListener('keyup', escapeHandler);
    };
  }, dependencies);
};

var _default = useEscapeHandler;
exports["default"] = _default;